import React from 'react';
import { IconProps } from '../../types/icon';

const ExcelIcon: React.FC<IconProps> = ({ className, size = 16 }) => {
  return (
    <img
      src="/gitex-illustrations/ExcelIcon.png"
      alt="Excel Spreadsheet"
      width={size}
      height={size}
      className={className}
      style={{ objectFit: 'contain' }}
    />
  );
};

export default ExcelIcon;